import http from '../axios.ts'
import {sha256} from "js-sha256";

const api = {

    /**
     * 分页查询
     */
    getAllByPage(data:Object) {
        const res = http.post('/order/getAllByPage',data);
        console.log(res);
        return res;
    },

    /**
     * 取消订单
     */
    cancel(data:Object) {
        const res = http.post('/order/cancel',data);
        console.log(res);
        return res;
    },

    /**
     * 管理员吊销订单
     */
    refund(data:Object) {
        const res = http.post('/order/refund',data);
        console.log(res);
        return res;
    },

}


export default api
